import axios from "axios";
import configs from "../../../../configurations/configs";

const IP = configs.SERVER_IP;

const state = {
  inbox: [],
  outbox: [],
};

const getters = {
  getInbox: (state) => state.inbox,
  getOutbox: (state) => state.outbox,
};

const actions = {
  async fetchInbox({ commit }, data) {
    await axios
      .post(IP + "/client/mail/incoming", data)
      .then((response) => {
        console.log(response.data);
        commit("setInboxResponse", response);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  async fetchOutbox({ commit }, data) {
    await axios
      .post(IP + "/client/mail/outgoing", data)
      .then((response) => {
        //console.log(response.data)
        commit("setOutboxResponse", response);
      })
      .catch((error) => {
        console.log(error);
      });
  },
};

const mutations = {
  setInboxResponse: (state, response) => {
    state.inbox = response.data.data;
  },
  setOutboxResponse: (state, response) => {
    state.outbox = response.data.data;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
